import React from 'react';

class ChatRoomNameOverlay extends React.Component{

	constructor(props){
		super(props);
	}

	render(){
		const name = this.props.name;
		if(name === undefined)
		{
			return null;
		}
		return (
			<div className={'chat_name_overlay ' + (this.props.active ? '' : 'done')}>
				<span className="chat_name">{name}</span>
			</div>
		);
	}
}

export {ChatRoomNameOverlay};